export const links = [
    "About",
    "My Skills",
    "Works",
    "Contact",
]